import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './button.css'

const Button = ({ type, text, onClick }) => (
  <button styleName={`button ${type}`} onClick={onClick}>
    {text}
  </button>
)

Button.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  type: PropTypes.string,
}

export default CSSModules(Button, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/button/button.js
 **/